import React from "react";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useLanguageContext } from "../../Context/LanguageContext";

export default function RenderFooter(props) {
  const {
    activeStep,

    handleNext,
    handleBack,
    completedPercentage,
    handleComplete,
  } = props;

  const { localization } = useLanguageContext();

  return (
    <React.Fragment>
      <div className="col-2">
        {activeStep > 0 && (
          <Button
            variant="contained"
            onClick={handleBack}
            style={{ backgroundColor: "#1976d2", color: "white" }}
          >
            {localization.back}
          </Button>
        )}
      </div>

      <div className="col">
        {activeStep !== 9 && (
          <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
              <LinearProgress
                variant="determinate"
                value={completedPercentage}
                style={{ height: "10px" }}
              />
            </Box>
            <Box minWidth={35}>
              <Typography variant="body2" color="textSecondary">
                {completedPercentage.toFixed(0) + "%"}
              </Typography>
            </Box>
          </Box>
        )}
      </div>
      <div className="col-3 text-right">
        {activeStep == 9 && (
          <Button
            variant="contained"
            style={{ backgroundColor: "green", color: "white" }}
            className="mr-2"
            onClick={handleComplete}
          >
            {localization.complete}
          </Button>
        )}
        {activeStep !== 9 && (
          <Button
            variant="contained"
            onClick={handleNext}
            style={{ backgroundColor: "#1976d2", color: "white" }}
          >
            {localization.nextStep}
          </Button>
        )}
      </div>
    </React.Fragment>
  );
}
